import * as fromActions from '../actions/chat.action'
import { Reducer } from 'redux'
import { IMessageModel } from 'store/states/message.state'

export const initialState: IMessageModel = {
  courseMessages: [],
  loading: false,
  conversationsList: [],
  courseUnreadMessagesCount: 0,
  unreadMessagesCount: 0,
}

export const reducer: Reducer<any> = (state: any = initialState, { type, payload }) => {
  switch (type) {
    case fromActions.CREATE_CHAT_MESSAGE: {
      return {
        ...state,
        loading: true,
      }
    }
    case fromActions.GET_CHAT_MESSAGES:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_CHAT_MESSAGES_SUCCESS:
      return {
        ...state,
        courseMessages: payload,
        loading: false,
      }
    case fromActions.GET_CONVERSATIONS:
      return {
        ...state,
      }
    case fromActions.GET_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        conversationsList: payload,
      }
    case fromActions.GET_CHAT_CONVERSATION_MESSAGES:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_COURSE_UNREAD_MESSAGES_COUNT_SUCCESS:
      return {
        ...state,
        courseUnreadMessagesCount: payload,
      }
    case fromActions.GET_UNREAD_MESSAGES_COUNT_SUCCESS:
      return {
        ...state,
        unreadMessagesCount: payload,
      }

    default:
      return state
  }
}
